"use strict";

var uniq = require('lodash/uniq');

var capitalize = require('lodash/capitalize');

var startCase = require('lodash/startCase');

var upperCase = require('lodash/upperCase');

var pluralize = require('./pluralize');

var toUpperCase = require('./toUpperCase');

var lowerCase = require('./lowerCase');

var join = require('./join');

var yesno = require('./yesno');

var dimensions = require('./dimensions');

var signSets = require('./signSets');

var orientation = require('./orientation');

module.exports = {
  uniq: uniq,
  toUpperCase: toUpperCase,
  upperCase: upperCase,
  pluralize: pluralize,
  capitalize: capitalize,
  lowerCase: lowerCase,
  startCase: startCase,
  join: join,
  yesno: yesno,
  dimensions: dimensions,
  signSets: signSets,
  orientation: orientation
};